import { Location } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { CardComponent } from '@app/components/card';
import { SpinnerComponent } from '@app/components/spinner';
import {
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextSpacing,
  TextType,
  TextWeight,
} from '@app/components/text';
import { TitleComponent, TitleSpacing } from '@app/components/title-section';
import {
  ViewComponent,
  ViewDirection,
  ViewSpacing,
} from '@app/components/view';
import { AdminChallengesService } from '@app/services/admin-challenges/admin-challenges.service';
import { Spacing } from '@app/shared/types';
import {
  GroupChallengeTeamMemberV2,
  GroupChallengeTeamV2,
  GroupChallengeWithTeams,
} from '@skyfit/core-data-library';

@Component({
  selector: 'app-challenge-leaderboard',
  standalone: true,
  imports: [
    CardComponent,
    TitleComponent,
    TextComponent,
    ViewComponent,
    SpinnerComponent,
  ],
  templateUrl: './challenge-leaderboard.component.html',
  styleUrl: './challenge-leaderboard.component.scss',
})
export class ChallengeLeaderboardComponent implements OnInit {
  private readonly location = inject(Location);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  private readonly challengesService = inject(AdminChallengesService);
  isLoading = signal(true);
  challengeId!: string;
  teamId!: string;
  challenge!: GroupChallengeWithTeams;
  team!: GroupChallengeTeamV2;
  members!: GroupChallengeTeamMemberV2[];
  TextType = TextType;
  TextSize = TextSize;
  TextHeight = TextHeight;
  TextWeight = TextWeight;
  TextColor = TextColor;
  TextSpacing = TextSpacing;
  ViewDirection = ViewDirection;
  ViewSpacing = ViewSpacing;
  TitleSpacing = TitleSpacing;
  Spacing = Spacing;

  ngOnInit() {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async (params) => {
        this.challengeId = params.id;
        this.teamId = params.teamId;
        this.challengesService
          .getGroupChallengeScores(params.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (challenge) => {
              this.challenge = challenge;
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              this.team = challenge.teams.find(
                (team) => team.teamId.toString() == this.teamId
              )!;
              this.members = this.team.members;
              this.isLoading.set(false);
            },
          });
      });
  }

  getOrdinalSuffix(rank: number): string {
    if (rank % 100 >= 11 && rank % 100 <= 13) {
      return `${rank}th Place`;
    }

    const lastDigit = rank % 10;
    switch (lastDigit) {
      case 1:
        return `st Place`;
      case 2:
        return `nd Place`;
      case 3:
        return `rd Place`;
      default:
        return `th Place`;
    }
  }

  goBack(): void {
    this.location.back();
  }
}
